import { render, staticRenderFns } from "./ProuniStart.vue?vue&type=template&id=4ab9f0dc&scoped=true&"
import script from "./ProuniStart.vue?vue&type=script&lang=ts&"
export * from "./ProuniStart.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniStart.vue?vue&type=style&index=0&id=4ab9f0dc&scoped=true&lang=scss&"
import style1 from "./ProuniStart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9f0dc",
  null
  
)

export default component.exports